import request from '@/plugins/axios'

const baseURL = request.defaults.baseURL

export function chat(question, sessionId) {
	return request({
		url: 'ai/chat',
		method: 'POST',
		data: {
			question,
			sessionId
		}
	})
}

export function chatStream(question, sessionId, onContent, onComplete, onError) {
	const data = {
		question,
		sessionId
	}

	fetch(`${baseURL}ai/chat/stream`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'identification': window.localStorage.getItem('identification') || ''
		},
		body: JSON.stringify(data)
	}).then(response => {
		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`)
		}

		const reader = response.body.getReader()
		const decoder = new TextDecoder()
		let buffer = ''

		function read() {
			reader.read().then(({ done, value }) => {
				if (done) {
					if (onComplete) {
						onComplete({})
					}
					return
				}

				buffer += decoder.decode(value, { stream: true })
				const lines = buffer.split('\n')
				buffer = lines.pop() || ''

				let currentEvent = null
				for (let i = 0; i < lines.length; i++) {
					const line = lines[i]
					if (line.startsWith('event:')) {
						currentEvent = line.substring(6).trim()
					} else if (line.startsWith('data:') && currentEvent) {
						const data = line.substring(5)
						if (currentEvent === 'content') {
							if (onContent) {
								const unescapedData = data.replace(/\\n/g, '\n').replace(/\\r/g, '\r')
								onContent(unescapedData)
							}
						} else if (currentEvent === 'done') {
							try {
								const jsonData = JSON.parse(data)
								if (onComplete) {
									onComplete(jsonData)
								}
							} catch (e) {
								if (onComplete) {
									onComplete(data)
								}
							}
						} else if (currentEvent === 'error') {
							if (onError) {
								onError(new Error(data))
							}
						}
						currentEvent = null
					}
				}

				read()
			}).catch(error => {
				if (onError) {
					onError(error)
				}
			})
		}

		read()
	}).catch(error => {
		if (onError) {
			onError(error)
		}
	})
}

export function createSession() {
	return request({
		url: 'ai/session',
		method: 'POST'
	})
}

export function getSessionHistory(sessionId) {
	return request({
		url: 'ai/session/history',
		method: 'GET',
		params: {
			sessionId
		}
	})
}

export function searchKnowledge(keyword, topK) {
	return request({
		url: 'knowledge/search',
		method: 'GET',
		params: {
			keyword,
			topK: topK || 5
		}
	})
}
